import styles from './OpenDataShared.module.scss';

export const TermsOfUseFooter = () => (
  <div className={styles.Information}>
    <h3 className={styles.TitleH3}>Условия использования набора данных</h3>
    <p>
      Пользователь без заключения договора с Федеральной службой государственной статистики может использовать (в том
      числе повторно) открытые данные свободно, бесплатно, бессрочно, объединять их с другой информацией, использовать
      открытые данные в некоммерческих целях, использовать для создания программ для ЭВМ и приложении.
    </p>
    <p>При использовании открытых данных Пользователь обязан:</p>
    <ul>
      <li>Использовать открытые данные только в законных целях;</li>
      <li>Не искажать открытые данные при их использовании;</li>
      <li>Сохранять ссылку на источник информации при использовании открытых данных</li>
    </ul>
  </div>
);
